import * as React from 'react';

/**
 * handles keypress in keyboard navigation
 * @param {HTMLEvent} event - The keyDown event
 * @param {Function} open - A callback function to be executed on pressing Space or ArrowDown
 * @param {Function} close - A callback function to be executed on pressing Escape
 */
const handleDropdownKeyPress = (event: React.KeyboardEvent<HTMLElement>, open: Function, close: Function) => {
    event.stopPropagation();

    const { key } = event;
    switch (key) {
        case ' ':
        case 'ArrowDown':
            return open();
        case 'ArrowRight':
            if (document.activeElement.nextElementSibling) {
                (document.activeElement.nextElementSibling as HTMLElement).focus();
            }

            break;
        case 'ArrowLeft':
        case 'ArrowUp':
            if (document.activeElement.previousElementSibling) {
                (document.activeElement.previousElementSibling as HTMLElement).focus();
            }

            break;
        case 'Escape':
            return close();
    }

    return null;
};

export default handleDropdownKeyPress;
